import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from '../entity';

@JsonObject('sort')
export class Sort extends Entity {
  @JsonProperty('orderBy', String)
  orderBy?: string = undefined;
  @JsonProperty('direction', String)
  direction?: string = undefined; 
}